export default __webpack_public_path__ + "static/media/play.af3a6b04.svg";